<!--
 * @Author: Merlin
 * @Date: 2025-01-22 18:33:17
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-18 17:48:50
 * @Description: 舞台上的小人儿 
-->

<template>
    <div
        class="man transform"
        :class="[
            man.animation,
            status === 'lose' ? 'die' : '',
            (round.multi && round.field.length === 13 && !man.isPopup) ? 'win' : '',
            man.animation ? 'duration-500' : ''
        ]"
        :style="`left: ${man.position.x}%; bottom: ${man.position.y}px;`"
    ></div>
    
</template>

<script lang="ts" setup>
const props = defineProps({
    man: {
        type: Object,
        required: true,
    },
    status: {
        type: String,
        required: true,
    },
    round: {
        type: Object,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
.man {
    bottom: 0;
    height: 30px;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    transform: translate(-50%);
    width: 30px;
    will-change: transform;
    z-index: 3;
}
.man::before {
    background-image: url('../img/run.webp');
    content: '';
    height: 100%;
    position: absolute;
    width: 100%;
    background-size: 236px;
}

.die::before {
    animation: dieAnimate 0.2s steps(7) forwards;
    background-image: url('../img/die.webp');
    content: '';
    height: 100%;
    position: absolute;
    width: 100%;
    background-size: 270px;
    height: 28px;
    width: 34px;
}
.win::before {
    animation: winAnimate 0.3s steps(8) infinite;
    background-image: url('../img/win.webp');
    content: '';
    height: 100%;
    position: absolute;
    width: 100%;
    background-size: 236px;
    height: 28px;
    width: 34px;
}

.run::before {
    animation: runAnimate 0.3s steps(8) infinite;
    background-image: url('../img/run.webp');
    content: '';
    height: 100%;
    position: absolute;
    width: 100%;
    background-size: 236px;
}

.climb::before {
    animation: climbAnimate 0.3s steps(8) infinite;
    background-image: url('../img/climb.webp');
    content: '';
    height: 100%;
    position: absolute;
    width: 100%;
    background-size: 236px;
}

@keyframes dieAnimate {
    0% {
        background-position: 0;
    }

    100% {
        background-position: -236px;
    }
}

@keyframes runAnimate {
    0% {
        background-position: 0;
    }

    100% {
        background-position: -236px;
    }
}

@keyframes climbAnimate {
    0% {
        background-position: 0;
    }

    100% {
        background-position: -236px;
    }
}

@keyframes winAnimate {
    0% {
        background-position: 0;
    }

    to {
        background-position: -236px;
    }
}
</style>
